import { lazy, Suspense, type JSX } from 'react';
import { useImageGallery } from '../../contexts/ImageGalleryContext';

const ImageGalleryWindow = lazy(() => import('./ImageGalleryWindow').then((m) => ({ default: m.ImageGalleryWindow })));
const ImageCompareWindow = lazy(() => import('./ImageCompareWindow').then((m) => ({ default: m.ImageCompareWindow })));

/** The gallery and the compare window are loaded only when opened (the main chunk stays small). */
export function ImageGalleryHost(): JSX.Element | null {
  const g = useImageGallery();
  if (!g?.open && !g?.comparing) return null;
  return (
    <Suspense fallback={null}>
      {g.open ? <ImageGalleryWindow /> : null}
      {g.comparing ? <ImageCompareWindow /> : null}
    </Suspense>
  );
}
